import { AccountInvestmentObjectivesDto, AccountTimeHorizonDto } from 'src/dtos';
import { AccountInvestmentObjectivesLabel, AccountTimeHorizonLabel } from 'src/models';

export const INVESTMENT_OBJECTIVES_OPTION_LIST = [
  {
    label: AccountInvestmentObjectivesLabel.CapitalPreservation,
    value: AccountInvestmentObjectivesDto.CapitalPreservation,
    description: 'Preservation of capital with primary consideration on income.',
    alert:
      'Capital Preservation has Low Risk Tolerance. In order to qualify for My IPO Offers your Investment Objectives must be "Growth" or "Speculation"',
  },
  {
    label: AccountInvestmentObjectivesLabel.Income,
    value: AccountInvestmentObjectivesDto.Income,
    description: 'A balance between capital appreciation and income with a primary consideration being income.',
    alert:
      'Income has Low Risk Tolerance. In order to qualify for My IPO Offers your Investment Objectives must be "Growth" or "Speculation"',
  },
  {
    label: AccountInvestmentObjectivesLabel.GrowthAndIncome,
    value: AccountInvestmentObjectivesDto.GrowthAndIncome,
    description:
      'Dual Investment strategy that seeks both capital appreciation and current income generated through dividends or interest.',
    alert:
      'Growth and Income has Medium Risk Tolerance. In order to qualify for My IPO Offers your Investment Objectives must be "Growth" or "Speculation"',
  },
  {
    label: AccountInvestmentObjectivesLabel.Growth,
    value: AccountInvestmentObjectivesDto.Growth,
    description: 'Capital appreciation through quality equity investment and little or no income.',
  },
  {
    label: AccountInvestmentObjectivesLabel.Speculation,
    value: AccountInvestmentObjectivesDto.Speculation,
    description: 'Maximum capital appreciation with higher risk and little to no income',
  },
];

export const TIME_HORIZON_OPTION_LIST = [
  {
    label: AccountTimeHorizonLabel.Short,
    value: AccountTimeHorizonDto.Short,
    description:
      'I plan on keeping this account open and investing for less than 3 years to achieve my financial goals.',
    alert: 'In order to qualify for My IPO Offers your Time Horizon must be "Average" or "Long"',
  },
  {
    label: AccountTimeHorizonLabel.Average,
    value: AccountTimeHorizonDto.Average,
    description:
      'I plan on keeping this account open and investing for more than 4 years, but less than 7 years to achieve my financial goals',
  },
  {
    label: AccountTimeHorizonLabel.Long,
    value: AccountTimeHorizonDto.Long,
    description:
      'I plan on keeping this account open and investing for more than 8+ years to achieve my financial goals.',
  },
];
